export default "__VITE_ASSET__2fe3c1cc__"